// Shared UI primitives for the redesigned Federation CMS.
// Recreated with MUI v4 + makeStyles + inline styles (no Tailwind), matching the
// Claude Design handoff. Hover/transition states live in makeStyles; static layout
// uses inline styles driven by the token object.

import React, { useState } from 'react'
import { makeStyles, Drawer } from '@material-ui/core'
import TOKENS, { avatarColor } from './tokens'

/* ----------------------------------------------------------------- Icon ---- */

const ICON_PATHS = {
  chevronDown: <polyline points="6 9 12 15 18 9" />,
  chevronRight: <polyline points="9 6 15 12 9 18" />,
  chevronLeft: <polyline points="15 6 9 12 15 18" />,
  plus: (
    <>
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </>
  ),
  edit: (
    <>
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="m18.5 2.5 3 3L12 15l-4 1 1-4Z" />
    </>
  ),
  trash: (
    <>
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </>
  ),
  calendar: (
    <>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </>
  ),
  trophy: (
    <>
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
      <path d="M4 22h16" />
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
    </>
  ),
  layers: (
    <>
      <polygon points="12 2 2 7 12 12 22 7 12 2" />
      <polyline points="2 17 12 22 22 17" />
      <polyline points="2 12 12 17 22 12" />
    </>
  ),
  grid: (
    <>
      <rect x="3" y="3" width="7" height="7" />
      <rect x="14" y="3" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" />
      <rect x="3" y="14" width="7" height="7" />
    </>
  ),
  list: (
    <>
      <line x1="8" y1="6" x2="21" y2="6" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" />
      <line x1="3" y1="6" x2="3.01" y2="6" />
      <line x1="3" y1="12" x2="3.01" y2="12" />
      <line x1="3" y1="18" x2="3.01" y2="18" />
    </>
  ),
  drag: (
    <>
      <circle cx="9" cy="6" r="1.2" />
      <circle cx="9" cy="12" r="1.2" />
      <circle cx="9" cy="18" r="1.2" />
      <circle cx="15" cy="6" r="1.2" />
      <circle cx="15" cy="12" r="1.2" />
      <circle cx="15" cy="18" r="1.2" />
    </>
  ),
  users: (
    <>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </>
  ),
  mapPin: (
    <>
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0Z" />
      <circle cx="12" cy="10" r="3" />
    </>
  ),
  arrowRight: (
    <>
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </>
  ),
  play: <polygon points="5 3 19 12 5 21 5 3" />,
  filter: <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />,
  close: (
    <>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </>
  ),
  list: (
    <>
      <line x1="8" y1="6" x2="21" y2="6" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" />
      <line x1="3" y1="6" x2="3.01" y2="6" />
      <line x1="3" y1="12" x2="3.01" y2="12" />
      <line x1="3" y1="18" x2="3.01" y2="18" />
    </>
  ),
  bracket: (
    <>
      <path d="M7 3v18" />
      <path d="M17 3v18" />
      <path d="M7 7h4l3 5-3 5H7" />
      <path d="M17 12h-3" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </>
  ),
  download: (
    <>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </>
  ),
  sparkles: (
    <>
      <path d="M12 3 13.5 8.5 19 10l-5.5 1.5L12 17l-1.5-5.5L5 10l5.5-1.5Z" />
      <path d="M19 3v4" />
      <path d="M17 5h4" />
    </>
  ),
  sync: (
    <>
      <path d="M21 2v6h-6" />
      <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
      <path d="M3 22v-6h6" />
      <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4" />
      <path d="M12 8h.01" />
    </>
  ),
}

export const Icon = ({ name, size = 16, stroke = 1.75, style, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={stroke}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
    className={className}
    aria-hidden="true"
  >
    {ICON_PATHS[name] || null}
  </svg>
)

/* -------------------------------------------------------------- Logo mark -- */

export const MismatchMark = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
    <circle cx="10" cy="11" r="6.5" fill={TOKENS.blue} />
    <circle cx="22" cy="11" r="6.5" fill={TOKENS.coral} />
    <circle cx="16" cy="22" r="6.5" fill={TOKENS.amber} />
  </svg>
)

/* ------------------------------------------------------------------ Badge -- */

const BADGE_TONES = {
  neutral: { bg: TOKENS.surface2, color: TOKENS.text2, border: TOKENS.border, dot: TOKENS.pastDot },
  coral: { bg: TOKENS.coralSoft, color: TOKENS.coralDark, border: TOKENS.coralBorder, dot: TOKENS.coral },
  live: { bg: TOKENS.liveBg, color: TOKENS.liveText, border: TOKENS.liveBorder, dot: TOKENS.liveDot },
  upcoming: { bg: TOKENS.upcomingBg, color: TOKENS.upcomingText, border: TOKENS.upcomingBorder, dot: TOKENS.upcomingDot },
  past: { bg: TOKENS.pastBg, color: TOKENS.pastText, border: TOKENS.pastBorder, dot: TOKENS.pastDot },
  // Distinct blue tone for seasons backed by an external CMS integration.
  synced: { bg: 'rgba(79, 139, 214, 0.12)', color: '#2F6BB0', border: 'rgba(79, 139, 214, 0.30)', dot: TOKENS.blue },
}

export const Badge = ({ tone = 'neutral', dot = false, children, style, ...rest }) => {
  const t = BADGE_TONES[tone] || BADGE_TONES.neutral
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '0 8px',
        height: 22,
        fontSize: 11,
        fontWeight: 500,
        lineHeight: 1,
        border: `1px solid ${t.border}`,
        borderRadius: 999,
        background: t.bg,
        color: t.color,
        whiteSpace: 'nowrap',
        ...style,
      }}
      {...rest}
    >
      {dot && <span style={{ width: 6, height: 6, borderRadius: 999, background: t.dot }} />}
      {children}
    </span>
  )
}

// Friendly labels for the external CMS providers the backend reports (ExternalCmsType).
const CMS_PROVIDER_LABELS = {
  Hbf: 'HBF',
  HbfTest: 'HBF',
  TestCms: 'Test CMS',
}

const cmsProviderLabel = (provider) => CMS_PROVIDER_LABELS[provider] || provider

// Marks a season backed by an external CMS integration (a SyncedSeason record).
// `sync` is the season's `externalCmsSync` payload ({ provider, isPaused, lastSyncedAt }),
// or null/undefined when the season is not synced — in which case nothing is rendered.
// The visible label stays minimal ("Synced"); the season and provider live in the tooltip.
// The tooltip text shared by the sync badge and the standalone info icon: which
// season (and its external id) syncs from which provider, plus the last sync time.
const seasonSyncTitle = (sync, seasonName) => {
  const label = cmsProviderLabel(sync.provider)
  const season = seasonName ? `"${seasonName}"` : 'this season'
  const extId = sync.externalSeasonId ? ` (external id ${sync.externalSeasonId})` : ''
  return sync.isPaused
    ? `Syncing ${season}${extId} from ${label} is paused`
    : sync.lastSyncedAt
      ? `Synced ${season}${extId} from ${label} — last synced ${new Date(sync.lastSyncedAt).toLocaleString()}`
      : `Synced ${season}${extId} from ${label}`
}

export const SeasonSyncBadge = ({ sync, seasonName }) => {
  if (!sync) return null
  return (
    <Badge tone={sync.isPaused ? 'past' : 'synced'} title={seasonSyncTitle(sync, seasonName)} style={{ cursor: 'default' }}>
      <Icon name="sync" size={11} />
      {sync.isPaused ? 'Sync paused' : 'Synced'}
    </Badge>
  )
}

// A bare info icon carrying the same tooltip as SeasonSyncBadge — used next to the
// Sync action so the sync details are one hover away without a separate badge.
export const SeasonSyncInfo = ({ sync, seasonName }) => {
  if (!sync) return null
  return (
    <span title={seasonSyncTitle(sync, seasonName)} style={{ display: 'inline-flex', color: TOKENS.text3, cursor: 'default' }}>
      <Icon name="info" size={16} />
    </span>
  )
}

/* ------------------------------------------------------------------- Card -- */

export const Card = ({ children, padded = true, style, className, ...rest }) => (
  <div
    className={className}
    style={{
      background: TOKENS.white,
      border: `1px solid ${TOKENS.border}`,
      borderRadius: TOKENS.radius,
      padding: padded ? 20 : 0,
      ...style,
    }}
    {...rest}
  >
    {children}
  </div>
)

export const SectionTitle = ({ children, hint, action }) => (
  <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: 12 }}>
    <div>
      <h3
        style={{
          margin: 0,
          fontSize: 13,
          fontWeight: 600,
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          color: TOKENS.text2,
        }}
      >
        {children}
      </h3>
      {hint && <p style={{ margin: '4px 0 0', fontSize: 12, color: TOKENS.text3 }}>{hint}</p>}
    </div>
    {action}
  </div>
)

/* ----------------------------------------------------------------- Avatar -- */

// Team names often carry the season ("ΕΣΚΑΘ 2025-2026"), so we drop tokens that are
// purely digits/punctuation (years, "2025-2026") before taking initials — otherwise the
// year leaks in ("Ε2"). Greek-safe: we only exclude numeric tokens rather than relying on
// \w, which doesn't match Greek letters.
const teamInitials = (name = '') => {
  const words = name.trim().split(/\s+/).filter((w) => w && !/^[\d./-]+$/.test(w))
  let initials
  if (words.length >= 2) initials = (words[0][0] || '') + (words[1][0] || '')
  else if (words.length === 1) initials = words[0].slice(0, 2)
  else initials = name.trim().slice(0, 2)
  return initials.toUpperCase()
}

export const Avatar = ({ name = '', src, color, size = 36 }) => {
  const [imgFailed, setImgFailed] = useState(false)
  const initials = teamInitials(name)
  if (src && !imgFailed) {
    return (
      <img
        src={src}
        alt={name}
        onError={() => setImgFailed(true)}
        style={{ width: size, height: size, borderRadius: TOKENS.radiusSm, objectFit: 'cover', flexShrink: 0 }}
      />
    )
  }
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: TOKENS.radiusSm,
        background: color || avatarColor(name),
        color: TOKENS.white,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 600,
        fontSize: size * 0.42,
        letterSpacing: -0.3,
        flexShrink: 0,
      }}
    >
      {initials}
    </div>
  )
}

/* ------------------------------------------------------------ ProgressBar -- */

export const ProgressBar = ({ value, total, tone = 'coral' }) => {
  const pct = !total ? 0 : Math.round((value / total) * 100)
  const color = tone === 'live' ? TOKENS.liveDot : TOKENS.coral
  return (
    <div style={{ width: '100%', height: 6, background: TOKENS.surface2, borderRadius: 999, overflow: 'hidden' }}>
      <div style={{ height: '100%', width: `${pct}%`, background: color, transition: 'width .3s' }} />
    </div>
  )
}

/* --------------------------------------------------------------- IconBtn --- */

const useIconBtnStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 28,
    height: 28,
    borderRadius: TOKENS.radiusSm,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    transition: 'background .15s, color .15s',
    padding: 0,
  },
  neutral: { color: TOKENS.text3, '&:hover': { color: TOKENS.text, background: TOKENS.surface2 } },
  coral: { color: TOKENS.coral, '&:hover': { background: TOKENS.coralSoft } },
  danger: { color: TOKENS.danger, '&:hover': { background: TOKENS.dangerSoft } },
})

export const IconBtn = ({ icon, tone = 'neutral', size = 14, onClick, title, style }) => {
  const c = useIconBtnStyles()
  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      className={`${c.root} ${c[tone]}`}
      style={style}
    >
      <Icon name={icon} size={size} />
    </button>
  )
}

/* ---------------------------------------------------------------- Button --- */

const useButtonStyles = makeStyles({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 500,
    fontFamily: TOKENS.font,
    border: '1px solid transparent',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background .15s, border-color .15s, color .15s',
    '&:disabled': { opacity: 0.55, cursor: 'not-allowed' },
  },
  primary: {
    background: TOKENS.coral,
    color: TOKENS.white,
    boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
    '&:hover': { background: TOKENS.coralDark },
  },
  outline: {
    background: TOKENS.white,
    color: TOKENS.text,
    borderColor: TOKENS.border,
    '&:hover': { background: TOKENS.surface2 },
  },
  subtle: {
    background: TOKENS.surface2,
    color: TOKENS.text,
    '&:hover': { background: TOKENS.surface3 },
  },
  ghost: {
    background: 'transparent',
    color: TOKENS.text,
    '&:hover': { background: TOKENS.surface2 },
  },
  danger: {
    background: TOKENS.white,
    color: TOKENS.danger,
    borderColor: TOKENS.border,
    '&:hover': { background: TOKENS.dangerSoft },
  },
  sm: { height: 28, padding: '0 10px', fontSize: 12, gap: 6, borderRadius: TOKENS.radiusSm },
  md: { height: 36, padding: '0 14px', fontSize: 13, gap: 8, borderRadius: TOKENS.radiusSm },
})

export const Button = ({ variant = 'primary', size = 'md', icon, iconRight, children, onClick, disabled, type = 'button', style }) => {
  const c = useButtonStyles()
  const iconSize = size === 'sm' ? 14 : 16
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${c.base} ${c[variant]} ${c[size]}`}
      style={style}
    >
      {icon && <Icon name={icon} size={iconSize} />}
      {children}
      {iconRight && <Icon name={iconRight} size={iconSize} />}
    </button>
  )
}

/* ------------------------------------------------------------------ Tabs --- */

const useTabsStyles = makeStyles({
  bar: { display: 'flex', alignItems: 'center', gap: 4, borderBottom: `1px solid ${TOKENS.border}` },
  tab: {
    position: 'relative',
    padding: '0 14px',
    height: 40,
    fontSize: 13,
    fontWeight: 500,
    fontFamily: TOKENS.font,
    background: 'transparent',
    border: 'none',
    borderBottom: '2px solid transparent',
    marginBottom: -1,
    cursor: 'pointer',
    color: TOKENS.text3,
    transition: 'color .15s',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    '&:hover': { color: TOKENS.text },
  },
  active: { color: TOKENS.text, borderBottom: `2px solid ${TOKENS.coral}` },
  count: {
    fontSize: 11,
    padding: '0 6px',
    height: 18,
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 999,
    background: TOKENS.surface2,
    color: TOKENS.text3,
  },
  countActive: { background: TOKENS.coralSoft, color: TOKENS.coralDark },
})

export const Tabs = ({ tabs, value, onChange }) => {
  const c = useTabsStyles()
  return (
    <div className={c.bar}>
      {tabs.map((t) => {
        const active = t.id === value
        return (
          <button key={t.id} onClick={() => onChange(t.id)} className={`${c.tab} ${active ? c.active : ''}`}>
            {t.label}
            {t.count !== undefined && (
              <span className={`${c.count} ${active ? c.countActive : ''}`}>{t.count}</span>
            )}
          </button>
        )
      })}
    </div>
  )
}

/* -------------------------------------------------------------- SlideOver -- */

const useSlideOverStyles = makeStyles({
  paper: { width: 480, maxWidth: '100vw', background: TOKENS.white, fontFamily: TOKENS.font },
  backdrop: { backgroundColor: 'rgba(15,23,42,0.3)' },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: 20,
    borderBottom: `1px solid ${TOKENS.border}`,
  },
  body: { flex: 1, overflowY: 'auto', padding: 20 },
  footer: {
    borderTop: `1px solid ${TOKENS.border}`,
    padding: 16,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8,
    background: TOKENS.surface,
  },
})

/* --------------------------------------------------- Expand / collapse all -- */

const useExpandCollapseStyles = makeStyles({
  btn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    height: 28,
    border: `1px solid ${TOKENS.border}`,
    background: TOKENS.white,
    cursor: 'pointer',
    fontFamily: TOKENS.font,
    fontSize: 12,
    fontWeight: 600,
    color: TOKENS.text2,
    padding: '0 12px',
    borderRadius: TOKENS.radiusSm,
    transition: 'color .12s, border-color .12s, background .12s',
    '&:hover': { color: TOKENS.coralDark, borderColor: TOKENS.coral, background: TOKENS.coralSoft },
  },
})

// Single toggle: collapses everything when all are open, otherwise expands everything.
export const ExpandCollapseControl = ({ allExpanded, onExpandAll, onCollapseAll, style }) => {
  const c = useExpandCollapseStyles()
  return (
    <button
      type="button"
      className={c.btn}
      style={style}
      onClick={allExpanded ? onCollapseAll : onExpandAll}
      title={allExpanded ? 'Collapse all' : 'Expand all'}
    >
      <Icon name={allExpanded ? 'chevronRight' : 'chevronDown'} size={12} stroke={2.5} />
      {allExpanded ? 'Collapse all' : 'Expand all'}
    </button>
  )
}

// Grab handle for react-beautiful-dnd rows. Pass the Draggable's dragHandleProps.
export const DragHandle = ({ handleProps }) => (
  <span
    {...handleProps}
    style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 18, flexShrink: 0, cursor: 'grab', color: TOKENS.text3 }}
    title="Drag to reorder"
    onClick={(e) => e.stopPropagation()}
  >
    <Icon name="drag" size={15} />
  </span>
)

export const SlideOver = ({ open, title, subtitle, onClose, children, footer }) => {
  const c = useSlideOverStyles()
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      classes={{ paper: c.paper }}
      ModalProps={{ BackdropProps: { className: c.backdrop } }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div className={c.header}>
          <div>
            <h2 style={{ margin: 0, fontSize: 15, fontWeight: 600, color: TOKENS.text }}>{title}</h2>
            {subtitle && <p style={{ margin: '4px 0 0', fontSize: 12, color: TOKENS.text3 }}>{subtitle}</p>}
          </div>
          <IconBtn icon="close" onClick={onClose} size={16} />
        </div>
        <div className={c.body}>{children}</div>
        {footer && <div className={c.footer}>{footer}</div>}
      </div>
    </Drawer>
  )
}

/* ---------------------------------------------------------- Form controls -- */

// `as="div"` for children that own their click handling (e.g. an image cropper): inside a
// <label>, a click anywhere in the field, blank space included, activates the first input.
export const Field = ({ label, hint, children, style, as: Tag = 'label' }) => (
  <Tag style={{ display: 'block', marginBottom: 16, ...style }}>
    <div style={{ fontSize: 12, fontWeight: 500, color: TOKENS.text2, marginBottom: 6 }}>{label}</div>
    {children}
    {hint && <div style={{ fontSize: 11, color: TOKENS.text3, marginTop: 4 }}>{hint}</div>}
  </Tag>
)

const useInputStyles = makeStyles({
  input: {
    width: '100%',
    height: 36,
    padding: '0 12px',
    fontSize: 13,
    fontFamily: TOKENS.font,
    background: TOKENS.white,
    border: `1px solid ${TOKENS.border}`,
    borderRadius: TOKENS.radiusSm,
    color: TOKENS.text,
    boxSizing: 'border-box',
    transition: 'border-color .15s, box-shadow .15s',
    '&:focus': { outline: 'none', borderColor: TOKENS.coral, boxShadow: `0 0 0 2px ${TOKENS.coralSoft}` },
    '&::placeholder': { color: TOKENS.text3 },
  },
})

export const TextInput = ({ style, ...props }) => {
  const c = useInputStyles()
  return <input {...props} className={c.input} style={style} />
}

export const SelectInput = ({ options = [], value, onChange, style, ...rest }) => {
  const c = useInputStyles()
  return (
    <div style={{ position: 'relative' }}>
      <select
        value={value}
        onChange={onChange}
        className={c.input}
        style={{ appearance: 'none', paddingRight: 32, ...style }}
        {...rest}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <span style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: TOKENS.text3 }}>
        <Icon name="chevronDown" size={14} />
      </span>
    </div>
  )
}

/* ----------------------------------------------------------------- Empty --- */

export const Empty = ({ icon = 'sparkles', title, hint, action }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '48px 24px' }}>
    <div
      style={{
        width: 48,
        height: 48,
        borderRadius: TOKENS.radius,
        background: TOKENS.surface2,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: TOKENS.text3,
        marginBottom: 12,
      }}
    >
      <Icon name={icon} size={20} />
    </div>
    <div style={{ fontSize: 14, fontWeight: 600, color: TOKENS.text }}>{title}</div>
    {hint && <div style={{ fontSize: 12, color: TOKENS.text3, marginTop: 4, maxWidth: 320 }}>{hint}</div>}
    {action && <div style={{ marginTop: 16 }}>{action}</div>}
  </div>
)

/* ------------------------------------------------------- Row hover helper -- */
// Reusable hover style for clickable cards/rows that turn coral on hover.
export const useHoverCard = makeStyles({
  card: {
    transition: 'border-color .15s, box-shadow .15s, background .15s',
    cursor: 'pointer',
    '&:hover': { borderColor: `${TOKENS.coral} !important`, boxShadow: '0 1px 3px rgba(0,0,0,0.08)' },
  },
  nameHover: { transition: 'color .15s', '&:hover': { color: TOKENS.coral } },
})
